<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:fuZhuPzmb:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入查询条件"
                            v-model="markName"
                            clearable>
                    </el-input>
                </div>
            </div>
        </div>
        <el-table
                height="500"
                :row-style="{height: '0'}"
                :cell-style="{padding: '3.5px',color:'#606266',fontSize:'13.5px'}"
                :header-row-style="{height: '40px'}"
                :header-cell-style="{padding: '5px',fontSize:'14px',color:'#909399'}"
                :data="tableData"
                :span-method="objectSpanMethod"
                :row-class-name="rowClassName"
                @cell-mouse-enter="handleMouseEnter"
                @cell-mouse-leave="handleMouseLeave"
                size="mini"
                id="elTableIdWW"
                border
                style="width: 100%; margin-top: 20px">
            <el-table-column
                    prop="mbna"
                    label="模版名称"
                    width="266">
            </el-table-column>
            <el-table-column
                    label="状态"
                    width="126">
                <template slot-scope="scope">
                    <span v-if="scope.row.sta=='0'"><span style="color: #35cc5c;">正常</span></span>
                    <span v-if="scope.row.sta=='1'"><span style="color: #f5bb34;">停用</span></span>
                </template>
            </el-table-column>
            <el-table-column
                    min-width="126" :show-overflow-tooltip="true"
                    prop="zyJl"
                    label="摘要">
            </el-table-column>
            <el-table-column
                    min-width="166" :show-overflow-tooltip="true"
                    prop="kmmc"
                    label="科目">

                <template slot-scope="scope">
                    {{scope.row.kmdm}}
                    {{scope.row.kmmc}}
                </template>

            </el-table-column>
            <el-table-column
                    prop="jfje"
                    label="借方金额(元)">
            </el-table-column>
            <el-table-column
                    prop="dfje"
                    label="贷方金额(元)">
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="mini" style="margin-right: 5px" v-if="$hasPerm('business:fuZhuPzmb:edit')" @click="handleEdit(scope.row)">编辑<i class="el-icon-edit"></i></el-button>
                    <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
                        <el-button size="mini" slot="reference" v-if="$hasPerm('business:fuZhuPzmb:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                style="margin-top: 5px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[5, 10, 20, 50, 90, 500]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
    </div>
</template>
<script>
    import Edit from './edit'

    export default {
        name: 'fuZhuPzmbList',
        components: {
            Edit
        },
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                markName: '',
                editVisible: false
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'markName': this.markName
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.rows;
                        this.total = r.data.data.total;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                })

            },
            // 合并规则
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0 || columnIndex === 1 || columnIndex === 6) {
                    if (row.rowFirst === true) {
                        return {
                            rowspan: row.rowspan,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        }
                    }
                }
            },
            // 给相应的rowIndex添加类名
            rowClassName({row}) {
                return row.mbId;
            },
            // 鼠标进入单元格
            handleMouseEnter(row) {
                $("." + row.mbId + "").addClass("in-row");
            },
            // 鼠标离开
            handleMouseLeave(row) {
                $("." + row.mbId + "").removeClass("in-row");
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(null, 0);
                })
            },
            handleEdit(row) {
                let id = row.mbId;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id, 1);
                })
            },
            handleDelete(row) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({id: row.mbId})
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>